import { create } from 'zustand';

interface VideoCommentState {
  highlightedCommentId: string | null;
  setHighlightedCommentId: (id: string | null) => void;
}

export const useVideoCommentStore = create<VideoCommentState>((set) => ({
  highlightedCommentId: null,
  setHighlightedCommentId: (id) => set({ highlightedCommentId: id }),
}));
